<template>
  <el-dialog :visible="recordDialogVisible" @close="closeDialog" width="1000px">
    <span slot="title">
      分红记录（{{ checkTask.dividendTime | moment('YYYY-MM-DD') }}）
    </span>
    <div>
      <el-button type="primary" @click="handleExecuteAllRecord"
        >执行所有</el-button
      >
    </div>
    <el-table :data="recordList">
      <el-table-column prop="userId" label="用户ID"> </el-table-column>
      <el-table-column prop="amount" label="分红金额"> </el-table-column>
      <el-table-column prop="coinType" label="分红币种"> </el-table-column>
      <el-table-column label="状态">
        <template slot-scope="scope">
          <!-- <el-tag
          :type="scope.row.__status.color"
        >{{scope.row.__status.text}}</el-tag> -->
          <span v-if="scope.row.status === 0">未执行</span>
          <span v-if="scope.row.stattus === 1">已执行</span>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="primary"
            @click="handleExecuteRecord(scope.row.id)"
            v-if="scope.row.status === 0"
            >执行</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="recordPagination.size"
      :page="recordPagination.page"
      :total="recordTotalCount"
      @pageChanged="handlePageChanged"
    >
    </pagination>
  </el-dialog>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import Pagination from 'components/pagination';

export default {
  name: 'DividendRecord',
  components: {
    Pagination
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {
    ...mapActions('dividendTask', [
      'listRecords',
      'executeRecord',
      'executeAllRecords'
    ]),
    ...mapMutations('dividendTask', ['setRecordDialogVisible']),
    closeDialog() {
      this.setRecordDialogVisible(false);
    },
    list(data = {}) {
      this.loading = true;
      this.listRecords({
        taskId: this.checkTask.id,
        ...this.recordPagination,
        ...data
      }).finally(() => {
        this.loading = false;
      });
    },
    handlePageChanged(pagination) {
      this.list(pagination);
    },
    handleExecuteRecord(id) {
      this.$confirm('确认进行该操作吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.executeRecord(id).then(() => {
          this.$message.success('操作成功！');
          this.list();
        });
      });
    },
    handleExecuteAllRecord() {
      this.$confirm('确认进行该操作吗？', '提示', {
        type: 'warning'
      }).then(() => {
        this.executeAllRecords(this.checkTask.id).then(() => {
          this.$message.success('操作成功！');
          this.list();
        });
      });
    }
  },
  watch: {
    recordDialogVisible(val, oldVal) {
      if (val) {
        this.list({
          ...this.recordPagination,
          page: 1
        });
      }
    }
  },
  computed: {
    ...mapState('dividendTask', [
      'recordDialogVisible',
      'recordPagination',
      'recordTotalCount',
      'checkTask'
    ]),
    ...mapGetters('dividendTask', ['recordList'])
  }
};
</script>

<style lang="less" scoped></style>
